import type {
    HighlightResult,
    HighlightResultOption,
    Hit,
} from "algoliasearch";
import React from "react";

import type {
    ImageChooserBlock,
    ServerCmsModelsPagesArticleArticleTagLink,
} from "@reactivated";

export { SearchField } from "./SearchField";
export interface AlgoliaHit {
    objectID: string;
    title: string;
    subtitle?: string;
    url: string;
    search_description?: string;
    page_type?: string;
    author?: string;
    article_type?: string;
    tags?: ServerCmsModelsPagesArticleArticleTagLink[];
    image?: ImageChooserBlock;
    seo_image?: ImageChooserBlock;
}

export type LIHit = Hit<AlgoliaHit>;

export const HL_PRE = "__hl__";
export const HL_POST = "__/hl__";

function resolveHighlight(
    x: HighlightResult | undefined,
): HighlightResultOption | undefined {
    if (Array.isArray(x)) return resolveHighlight(x[0]);
    if (!x) return x;
    if ("value" in x) return x as HighlightResultOption;
    return undefined;
}

export const findMatchingThing = (item: LIHit): string | undefined => {
    if (!item._highlightResult) return undefined;
    for (const [key, value] of Object.entries(item._highlightResult)) {
        const highlight = resolveHighlight(value);
        if (highlight?.matchedWords.length) {
            const prop = item[key as keyof LIHit];
            if (typeof prop === "string") return prop;
        }
    }
    return undefined;
};

export const Highlighted = ({
    highlight,
    children,
    ...props
}: {
    highlight: undefined | HighlightResult;
} & React.ComponentProps<"span">) => {
    const resolved = resolveHighlight(highlight);
    if (!resolved || resolved.matchLevel === "none") {
        return <span {...props}>{children}</span>;
    }
    const parts = resolved.value.split(new RegExp(`${HL_PRE}(.*?)${HL_POST}`));
    return (
        <span {...props}>
            {parts.map((part, i) =>
                i % 2 === 1 ? <strong key={i}>{part}</strong> : part,
            )}
        </span>
    );
};
